export const EXPENSES = 'EXPENSES';
export const BUSINESS = 'BUSINESS';
export const DEBT_CONSOLIDATION = 'DEBT_CONSOLIDATION';
export const LARGE_ONE_OFF_PURCHASES = 'LARGE_ONE_OFF_PURCHASES';
export const BALANCE_TRANSFER = 'BALANCE_TRANSFER';

export const applicationReasonOptions = [
  { label: 'For everyday expenses and large one-off purchases', value: EXPENSES },
  { label: 'For business expenses', value: 'BUSINESS' },
  { label: 'For debt consolidation', value: 'DEBT_CONSOLIDATION' },
];

export const applicationReasonOptionsNZV2 = [
  { label: 'For everyday expenses', value: EXPENSES },
  { label: 'For large one-off purchases', value: LARGE_ONE_OFF_PURCHASES },
  { label: 'For a balance transfer from another credit card', value: BALANCE_TRANSFER },
];
